<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 512 531"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M84.8648 212.162H381.892V254.594H424.324V127.297C424.324 103.959 405.229 84.8648 381.892 84.8648H360.675V42.4324H318.243V84.8648H148.513V42.4324H106.081V84.8648H84.8648C61.3148 84.8648 42.6445 103.959 42.6445 127.297L42.4324 424.324C42.4324 447.662 61.3148 466.756 84.8648 466.756H233.378V424.324H84.8648V212.162ZM84.8648 127.297H381.892V169.73H84.8648V127.297ZM463.362 345.4L448.298 360.463L403.32 315.485L418.383 300.421C426.658 292.147 440.024 292.147 448.298 300.421L463.362 315.485C471.636 323.759 471.636 337.125 463.362 345.4ZM388.256 330.548L433.235 375.527L320.789 487.973H275.811V442.994L388.256 330.548Z"
      :fill="color"
    />
    <path
      d="M199.644 297.027L233.378 330.761L203.463 360.675L169.73 326.942L135.996 360.675L106.081 330.761L139.815 297.027L106.081 263.293L135.996 233.378L169.73 267.112L203.463 233.378L233.378 263.293L199.644 297.027Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'white'
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
}
</script>
